import { type PaymentMethodFundingSource } from '../types/PaymentsButtonViewConfig';

export const DH = {
  Widget: {
    RootWrapper: 'ecw-root-wrapper',
    ResourceLoader: 'ecw-resource-loader',
    PMList: 'ecw-payment-method-list',
    PMListItem: (name: PaymentMethodFundingSource) => `ecw-payment-method-list-item-${name}`,
    MorePoWrapper: 'ecw-more-po-wrapper',
    HorizontalLayoutDivider: 'ecw-horizontal-layout-divider',
    HorizontalLayoutFieldset: 'ecw-horizontal-layout-fieldset',
    ErrorBoundaryFallback: 'ecw-error-boundary-fallback',
  },
  GooglePay: {
    Button: 'ecw-google-pay-view-btn',
  },
  ApplePay: {
    Button: 'ecw-apple-pay-view-btn',
  },
  PayPal: {
    MockButtonPayPal: 'ecw-mock-btn-paypal',
    MockButtonPayPalCredit: 'ecw-mock-btn-credit',
    MockButtonPayLater: 'ecw-mock-btn-paylater',
    MockButtonVenmo: 'ecw-button-wrapper-venmo',
    ButtonWrapperPayPal: 'ecw-button-wrapper-paypal',
    ButtonWrapperCredit: 'ecw-button-wrapper-credit',
    ButtonWrapperPayLater: 'ecw-button-wrapper-paylater',
    ButtonWrapperVenmo: 'ecw-button-wrapper-venmo',
  },
  MorePaymentOptions: {
    Wrapper: 'ecw-more-payment-options-wrapper',
    Button: 'ecw-more-payment-options-button',
  },
};
